import React, { useContext, useEffect, useState } from "react";
import { getArtContestData } from "../services/artContestAppService";
import { LocalizationContext } from "../contexts/localization-context";
import useMasonry from "../hooks/useMasonry";
import MasonryColumn from "../components/MasonryColumn";
import Art from "../components/Art";
import { getCookie } from "../helpers/cookiesHelpers";
import { ArtsContext } from "../contexts/arts-context";
import ArtOverlayDesktop from "../components/ArtOverlayDesktop";
import ArtOverlayMobile from "../components/ArtOverlayMobile";

const ArtContestAppLayoutContainer = () => {
    const [votedArtId, setVotedArtId] = useState(
        getCookie("StreetArtVote") ? parseInt(getCookie("StreetArtVote")) : null
    );
    const { columns, isMobile, setMasonryItems } = useMasonry();
    const [localizationState, setLocalizationState] = useContext(LocalizationContext);
    const [arts, dispatchToArts] = useContext(ArtsContext);
    const [activeArt, setActiveArt] = useState(null);

    const culture = document.getElementById("votingCulture").value;
    const campaignName = document.getElementById("votingCampaignName").value;
    const nodeId = document.getElementById("votingNodeId").value;
    const translationVotes = document.getElementById("votingTranslationVotes").value;
    const translationAddVote = document.getElementById("votingTranslationAddVote").value;
    const translationRemoveVote = document.getElementById("votingTranslationRemoveVote").value;
    const voteIsEnabled = document.getElementById("votingEnabled").value === "True" ? true : false;

    const fetchData = async () => {
        const artContestData = await getArtContestData(culture, campaignName, nodeId);
        dispatchToArts({
            type: "SET_ARTS",
            payload: { arts: artContestData.votingItems },
        });

        setLocalizationState({
            votes: translationVotes,
            voteNow: translationAddVote,
            undoVote: translationRemoveVote,
        });
    };

    useEffect(() => {
        fetchData();
    }, []);

    useEffect(() => {
        setMasonryItems(arts);
    }, [arts]);

    return (
        <div className="container">
            <div className="flex mt-80 -mx-20 md:-mx-10 3xs:-mx-6">
                {columns.map((itemsIndexes, i) => (
                    <MasonryColumn key={i} index={i} items={arts} isMobile={isMobile}>
                        {itemsIndexes.map((itemIndex) => (
                            <Art
                                key={arts[itemIndex].nodeId}
                                art={arts[itemIndex]}
                                votedArtId={votedArtId}
                                setVotedArtId={setVotedArtId}
                                setActiveArt={setActiveArt}
                                campaignName={campaignName}
                                voteIsEnabled={voteIsEnabled}
                            />
                        ))}
                    </MasonryColumn>
                ))}
            </div>
            {activeArt && isMobile && (
                <ArtOverlayMobile
                    activeArt={activeArt}
                    setActiveArt={setActiveArt}
                    votedArtId={votedArtId}
                    setVotedArtId={setVotedArtId}
                    campaignName={campaignName}
                />
            )}
            {activeArt && !isMobile && (
                <ArtOverlayDesktop
                    activeArt={activeArt}
                    setActiveArt={setActiveArt}
                    votedArtId={votedArtId}
                    setVotedArtId={setVotedArtId}
                    campaignName={campaignName}
                />
            )}
        </div>
    );
};

export default ArtContestAppLayoutContainer;
